import React, { useState, useEffect } from 'react';
import Wrapper from './styles';
import { useHistory } from 'react-router-dom';
import { useUserContext } from '../../context/user_context';
import useQuery from '../../hooks/useQuery';
import { toast } from 'react-toastify';

function ResetPasswordPage({email}) {
  const history = useHistory();
  const { resetPassword } = useUserContext();
  const query = useQuery();
  const [password, setPassword] = useState('');
  const {updateUserDetails}=useUserContext()

  const handleSubmit = async(e) => {
    e.preventDefault();
    let res=await updateUserDetails('password', password, null, true, email);
    if(res){
       history.push('/login');
    }
 };

  useEffect(() => {
    document.title = 'Mukunda jewelery | Reset Password';
  }, []);

  return (
    <Wrapper className='page-100'>
      <div>
        <div className='title'>
          <h2>Reset</h2>
        </div>
        <form onSubmit={handleSubmit}>
          {/* email */}
          <div className='form-control'>
            <input
              type='password'
              className='input'
              placeholder='new password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {/* end email */}
          <button type='submit' className='btn reset-btn'>
            reset
          </button>
        </form>
      </div>
    </Wrapper>
  );
}

export default ResetPasswordPage;
